import { Helmet } from "react-helmet-async";

const BASE_URL = "https://ratnatrraya.consulting";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_cxo-placement/artifacts/o33cdnbv_profile_pic.png";

export const SEO = ({ title, description, path = "/", keywords = "" }) => {
  const fullTitle = title
    ? `${title} | Ratnatrraya Consulting LLP`
    : "Ratnatrraya Consulting LLP | Accounting, Tax & Micro CFO Services for Small Businesses";
  const url = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};
